import { render, staticRenderFns } from "./WithdrawManage.vue?vue&type=template&id=3120bebe&scoped=true"
import script from "./WithdrawManage.vue?vue&type=script&lang=js"
export * from "./WithdrawManage.vue?vue&type=script&lang=js"
import style0 from "./WithdrawManage.vue?vue&type=style&index=0&id=3120bebe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120bebe",
  null
  
)

export default component.exports